import { render, staticRenderFns } from "./MyCase.vue?vue&type=template&id=14549c62&scoped=true"
import script from "./MyCase.vue?vue&type=script&lang=js"
export * from "./MyCase.vue?vue&type=script&lang=js"
import style0 from "./MyCase.vue?vue&type=style&index=0&id=14549c62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14549c62",
  null
  
)

export default component.exports